import { useEffect, useState } from "react";
import { CircleChevronLeft } from "lucide-react";
import toast from "react-hot-toast";
import { InverntroyService } from "../services/api/inventroy.service";
import { ManufacturerData } from "../components/Inventory-Stocks & Orders/Admin/InventoryManagement/types";

const AddNewManufacturerModal = ({
  onClose,
  selectedWholeSaler,
}: {
  onClose: () => void;
  selectedWholeSaler: ManufacturerData;
}) => {
  const [formData, setFormData] = useState({
    manufacturerName: "",
    manufacturerAddress: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await InverntroyService.addNewmanufacturer(formData);
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error((error as Error)?.message || "An error occurred");
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await InverntroyService.updateManufacturerDetails(
        selectedWholeSaler.id,
        formData
      );
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error((error as Error)?.message || "An error occurred");
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  useEffect(() => {
    if (selectedWholeSaler) {
      setFormData({
        manufacturerName: selectedWholeSaler.manufacturer_name || "",
        manufacturerAddress: selectedWholeSaler.manufacturer_address || "",
      });
    }
  }, []);

  return (
    <div className="flex w-full">
      <div className="w-full">
        <div className="flex items-center mb-4">
          <button
            disabled={isLoading}
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <CircleChevronLeft className="w-6 h-6 bg-[#808080] text-white rounded-full mr-2" />
          </button>
          <h2 className="font-medium text-lg text-emerald-600">
            {selectedWholeSaler ? "UPDATE MANUFACTURE" : "ADD NEW MANUFACTURE"}
          </h2>
        </div>

        <div className="border border-gray-300 bg-white shadow-lg rounded-xl mt-3 p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Manufacture Name
              </label>
              <input
                type="text"
                name="manufacturerName"
                value={formData.manufacturerName}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter name"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Manufacture Address
              </label>
              <textarea
                name="manufacturerAddress"
                value={formData.manufacturerAddress}
                onChange={handleChange as any}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter address"
                rows={1}
              />
            </div>
          </div>

          <div className="flex justify-center space-x-4">
            {selectedWholeSaler ? (
              <button
                onClick={handleUpdate}
                disabled={isLoading}
                className={`px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:bg-gray-200 disabled:cursor-not-allowed`}
              >
                {isLoading ? "Updating..." : "Update Manufacturer"}
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={isLoading}
                className={`px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:bg-gray-200 disabled:cursor-not-allowed`}
              >
                {isLoading ? "Adding..." : "Add Manufacturer"}
              </button>
            )}

            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 w-24"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewManufacturerModal;
